import {
  PaymentStatus,
  SerializableMap,
  TransactionAuthorizationResult,
} from '../models';

export function getPaymentStatus(
  transactionResults: TransactionAuthorizationResult[],
): PaymentStatus {
  if (
    transactionResults.length === 0 ||
    transactionResults.some((transaction) => transaction.gpalStatus == null)
  ) {
    return PaymentStatus.UNKNOWN;
  }

  // ALL logic
  // if all transactions are successful:
  if (
    transactionResults.every(
      (transaction) =>
        transaction.gpalStatus === PaymentStatus.APPROVED ||
        transaction.gpalStatus === PaymentStatus.SCHEDULED ||
        transaction.gpalStatus === PaymentStatus.SUCCESS,
    )
  ) {
    return PaymentStatus.SUCCESS;
  }
  // if all transactions are PENDING (polling/cancellation):
  if (
    transactionResults.every(
      (transaction) => transaction.gpalStatus === PaymentStatus.IN_PROGRESS,
    )
  ) {
    return PaymentStatus.PROCESSING;
  }
  // if all transactions are FAILED (HttpErrorResponse)
  if (
    transactionResults.every(
      (transaction) =>
        transaction.gpalStatus === PaymentStatus.FAILED ||
        transaction.gpalStatus === PaymentStatus.DECLINED,
    )
  ) {
    return PaymentStatus.FAILED;
  }
  // if all transactions are TIMED OUT (PaymentTimeoutError)
  if (
    transactionResults.every(
      (transaction) => transaction.gpalStatus === PaymentStatus.TIMEOUT,
    )
  ) {
    return PaymentStatus.TIMEOUT;
  }

  // COMBO LOGIC
  // if transactions contain at least 1 FAILED:
  if (
    transactionResults.some(
      (transaction) => transaction.gpalStatus === PaymentStatus.FAILED,
    )
  ) {
    return PaymentStatus.SOME_FAILED;
  }
  // if transactions contain at least 1 PENDING or at least 1 TIMEOUT:
  if (
    transactionResults.some(
      (transaction) =>
        transaction.gpalStatus === PaymentStatus.IN_PROGRESS ||
        transaction.gpalStatus === PaymentStatus.TIMEOUT,
    )
  ) {
    return PaymentStatus.SOME_PROCESSING;
  }

  return PaymentStatus.UNKNOWN;
}

export function getPaymentStatusFromResultMap(
  transactionResultMap: SerializableMap<TransactionAuthorizationResult>,
) {
  return getPaymentStatus(Object.values(transactionResultMap));
}

export function isPaymentComplete(status: PaymentStatus) {
  return [
    PaymentStatus.SUCCESS,
    PaymentStatus.SOME_FAILED,
    PaymentStatus.SOME_PROCESSING,
    PaymentStatus.PROCESSING,
  ].includes(status);
}

export function isPaymentResultComplete(
  transactionResultMap: SerializableMap<TransactionAuthorizationResult>,
) {
  return isPaymentComplete(getPaymentStatusFromResultMap(transactionResultMap));
}
